import { IsOptional } from 'class-validator';

export class LanguageFilter {
	@IsOptional()
	languages: string;
}
